import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {DocumentsService} from "../../../../../services/document.service";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {UtilsService} from "../../../../../services/utils.service";
import Swal from "sweetalert2";
declare var $: any;

@Component({
  selector: 'app-registro-ejercicios',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    FormsModule,
    NgClass
  ],
  templateUrl: './registro-ejercicios.component.html',
  styleUrl: './registro-ejercicios.component.css'
})
export class RegistroEjerciciosComponent implements OnInit, OnChanges{
  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;

  @Output() programaActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice

  listaEjercicios: any = []
  listaEjerciciosDia: any = []
  fechaFormateada: any
  fechaTimeStamp: any
  notasEntrenador: any
  listaPorEjercicio: any = []
  indiceSeleccionado: any
  seccionActive: any;

  constructor(private documentService: DocumentsService,
              private utilsService: UtilsService) {
  }

  ngOnInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("=========================== onChanges Expediente Desde Ejercicios =======================================")
    this.indiceSeleccionado = 0
    this.seccionActive = 'registro'
    this.getEjerciciosRegistradosXCliente()
    this.obtieneFechaActual()
  }

  changeSeccionActive(value: 'registro') {
    this.seccionActive = value;
  }

  getEjerciciosRegistradosXCliente(){
    this.listaEjerciciosDia = []
    this.documentService.getAttachmentByType(environment.businessId, this.detalleCliente.documentId, 'ejercicioCliente').subscribe((res: any) => {

      let arrSort: any = []
      arrSort= res.content

      arrSort = arrSort.sort((a, b) => a.timestamp - b.timestamp);

      this.listaEjerciciosDia = arrSort
      for(let x in this.listaEjerciciosDia){
          let day = ['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab'][new Date(this.listaEjerciciosDia[x].timestamp*1000).getDay()]
        let month = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'][new Date(this.listaEjerciciosDia[x].timestamp*1000).getMonth()]

          this.listaEjerciciosDia[x].diaLetra = day;
          this.listaEjerciciosDia[x].mesLetra = month;
      }

      let arr: any = []
      arr = res.content

      let op = arr.reduce((op,inp)=>{
        op[inp.ejercicioId] = inp
        return op
      },{})

      this.listaEjercicios = Object.values(op)
      this.filtraEjercicio(this.listaEjercicios[0], 0)

    }, err => {
      console.error(err)
    })
  }

  agregarNotasEntrenador(){
      let objeto: any = {}
      let objetoEntrenador: any = {}
      let attchId = this.utilsService.create_UUID()
      let ultimoElemento: any = this.listaPorEjercicio[this.listaPorEjercicio.length - 1]

      objetoEntrenador = {
        "attachmentId": attchId,
        "documentId": this.detalleCliente.documentId,
        "ejercicioId": ultimoElemento.ejercicioId,
        "fecha": this.fechaFormateada,
        "timestamp": this.fechaTimeStamp,
        "detalleEjercicio": ultimoElemento.detalleEjercicio,
        "instrucciones": "",
        "comentariosCliente": "",
        "registroEntrnador": true,
        "comentariosEntrenador": this.notasEntrenador,
        "series": []
      }

      this.documentService.createDocumentAttachment(
          environment.businessId,
          this.detalleCliente.documentId,
          attchId,
          'ejercicioCliente',
          null,
          objetoEntrenador
      ).subscribe({
        next: (response: any) => {
          // this.entrenadores.push(response);
          let day = ['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab'][new Date(objetoEntrenador.timestamp*1000).getDay()]
          objetoEntrenador.diaLetra = day
          this.listaEjerciciosDia.push(objetoEntrenador)
          this.listaPorEjercicio.push(objetoEntrenador)
          this.notasEntrenador = ''
          Swal.fire({
            toast: true, // Activa el estilo tipo Toast
            position: 'bottom-end', // Posición del mensaje
            icon: 'success',
            title: 'Registro éxitoso',
            showConfirmButton: false,
            timer: 3000, // Tiempo de duración del mensaje (3 segundos)
            timerProgressBar: true // Muestra una barra de progreso
          });
        },
        error: (error) => {
          console.log(error);
        },
        complete: () => {
          console.log('complete')
        }
      })
  }

    obtieneFechaActual(){
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm: any = today.getMonth() + 1; // Months start at 0!
      let dd: any = today.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      const formattedToday = dd + '-' + mm + '-' + yyyy;
      this.fechaFormateada = formattedToday;

      let myDate: any = formattedToday;
      myDate = myDate.split("-");
      let newDate = new Date( myDate[2], myDate[1] - 1, myDate[0]);

      const dateTimestamp = (newDate.getTime() / 1000) + 28800
      this.fechaTimeStamp = dateTimestamp
    }

    filtraEjercicio(ejercicio, indice){
      this.indiceSeleccionado = indice
      let arrEjercicio: any = []

      for(let i in this.listaEjerciciosDia){
        if(ejercicio.ejercicioId == this.listaEjerciciosDia[i].ejercicioId){
          arrEjercicio.push(this.listaEjerciciosDia[i])
        }
      }

      this.listaPorEjercicio = arrEjercicio
      $('textarea').focus();

    }
}
